<template>
	<div class="nav-bar">
		<div class="title" :style="{color:(textcolor==0?'#fff':'#000')}">
			<div class="blak" v-if="isblack" @click="blackclick">
				<img v-if="textcolor == 0" class="img" src="../../src/assets/wback.png" alt="" />
				<img v-if="textcolor == 1" class="img" src="../../src/assets/hback.png" alt="" />
			</div>
			<div class="nav_title">{{ text }}</div>
		</div>
	</div>
</template>
<!--  ../../src/assets/wback.png -->
<script>
	export default {
		props: {
			text: {
				type: String,
				default: "首页",
			},
			isblack: {
				type: Boolean,
				default: false,
			},
			textcolor: {
				type: Number,
				default: "0",
			},
		},
		methods: {
			blackclick() {
				this.$emit("blackclick");
			},
		},
	};
</script>

<style scoped>
	.nav-bar {
		position: relative;
	}

	.title {
		margin-top: 10px;
		height: 40px;
		/* background-color: #fff; */
		color: #000;
		line-height: 40px;
		font-size: 16px;
		position: fixed;
		width: 100%;
		right: 0;
		top: 0;
		z-index: 999;
		font-weight: 600;
		display: flex;
	}

	.blak {
		/* flex: 1; */
		font-size: 16px;
		font-weight: 700;
		display: flex;
		align-items: center;
		padding-left: 10px;
	}

	.nav_title {
		flex: 1;
		font-size: 18px;
		margin: 0 34%;
	}

	.search {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: right;
	}

	.img {
		width: 25px;
		height: 25px;
	}
</style>